import axios, {AxiosInstance} from 'axios';

const globalAxios: AxiosInstance = axios.create();

export default globalAxios;